import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getCountry, getCountryCode } from "../../utils/oneintelligence/OneIntelligenceHelper";
import OneIntelligenceServices from "../../services/OneIntelligence.services";

function useCountryFromMarketPackage(selectedMP) {
    const [countryList, setcountryList] = useState([]);
    const { loadingServers } = useSelector((state) => state.buildTargets);

    useEffect(() => { // Get all country per MP
        if (selectedMP) {
            const hasLoading = !Object.values(loadingServers).length ? true : !!Object.values(loadingServers).includes(true);
            const tempCountryList = getCountry(selectedMP);
            if (hasLoading) {
                setcountryList(tempCountryList.map((cty) => {
                    const tempCopy = { ...cty };
                    const result = OneIntelligenceServices.getSavantCountryObj(getCountryCode("savant", tempCopy));
                    tempCopy.loaded = result === undefined ? "proccessing" : !!result;
                    return tempCopy;
                }));
            } else {
                setcountryList(tempCountryList);
            }
        }
    }, [loadingServers, selectedMP]);

    return countryList;
}

export default useCountryFromMarketPackage;
